import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import Icon from '../icons/Icon';

const SidebarItem = ({ label, icon, url, pathname, isStrokeIcon, selectedRoutes = [], disabled }) => {
  return (
    <Link
      className={clsx('nav-link', disabled && 'nav-link--disabled', (pathname === url || selectedRoutes.includes(pathname)) && 'nav-link--active')}
      to={url}>
      <span className='nav-link_icon-wrapper'>
        <Icon
          icon={icon}
          size={18}
          className={clsx('nav-link_icon', isStrokeIcon && 'nav-link_icon--stroke')}
          disableCommonColors
        />
      </span>
      <span className='nav-link_label'>{label}</span>
    </Link>
  );
};

export default SidebarItem;
